const coerceValue = (value: string): boolean | string => {
	if (value === 'true') return true;
	if (value === 'false') return false;
	return value;
};

/**
 * Converts string 'true'/'false' values in a query object to actual booleans,
 * matching express-query-boolean behavior.
 */
export const coerceQueryBooleans = (
	query: Record<string, string | string[] | undefined>,
): Record<string, boolean | string | (boolean | string)[] | undefined> => {
	const result: Record<string, boolean | string | (boolean | string)[] | undefined> = {};

	for (const key of Object.keys(query)) {
		const value = query[key];

		if (Array.isArray(value)) {
			result[key] = value.map((v) => coerceValue(v));
		} else if (value !== undefined) {
			result[key] = coerceValue(value);
		} else {
			result[key] = value;
		}
	}

	return result;
};
